import Marionette from 'backbone.marionette'; //you need this or marionette will be undefined if user starts on this page
import Navigator from 'app';
import { MembersController } from './members_controller';
const MemberRouter = Marionette.AppRouter.extend({
  appRoutes: {
    "members": "showMembersHome",
    "members/:id": "showMemberDetail",
    // "members/:criterion" : "showMembersHome",
    "map": "activateMapTab"
  }
});
const API = {
  showMembersHome: function (criterion, homeview) {
    console.log("EMD API showMembersHome criterion: ", criterion, homeview);
    import( /* webpackChunkName: "members" */'./members_controller').then(module => {
      const MembersController = module.default;
      //const MembersController = Navigator.membersController;
      MembersController.showMembersHome(MembersController.showMembersBrowse, criterion, homeview);
      // Navigator.updateAnalytics("members");
    });
  },

  showMemberDetail: function (id, homeview) {
    import( /* webpackChunkName: "members" */'./members_controller').then(module => {
      const MembersController = module.default;
      //const MembersController = Navigator.membersController;
      MembersController.showMemberDetail(id, homeview);
      // Navigator.updateAnalytics("members", id);
    });
  },

  showMembersMap: function (homeview) {
    import( /* webpackChunkName: "members" */'./members_controller').then(module => {
      const MembersController = module.default;
      MembersController.showMembersHome(MembersController.showMembersMap, undefined, homeview);
      // Navigator.updateAnalytics("members", "map");
    });
  },

  // this only happens when user enters through /map route
  activateMapTab: function () {
    import( /* webpackChunkName: "members" */'./members_controller').then(module => {
      const MembersController = module.default;
      MembersController.showMembersHome(MembersController.activateMapTab);
      // no need to updateAnalytics here, activating map tab will trigger the same event path as if tab where clicked so it will be captured in a moment
    });
  }
};

Navigator.vent.on("member:home:show", function (criterion, homeview) {
  console.log("EMD on member:home:show criterion: ", criterion, homeview);
  Navigator.navigate("members");
  API.showMembersHome(criterion, homeview);
});
Navigator.vent.on("member:detail:show", function (id, homeview) {
  Navigator.navigate("members/" + id);
  API.showMemberDetail(id, homeview);
});
Navigator.vent.on("map:show", function (view) {
  Navigator.navigate("map");
  API.showMembersMap(view);
});
Navigator.on("before:start", function () {
  new MemberRouter({
    controller: API
  });
});
export { MemberRouter as default };